import styled from '@emotion/styled';

const FormWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export default FormWrapper;
